/**
 * 語言切換下拉 — 置於各頁 header。
 *
 * 切換即時生效（context re-render）並持久化至 localStorage。
 */
import { LOCALES, LOCALE_LABELS, type Locale } from '../lib/i18n';
import { useI18n } from '../lib/i18n-context';

export function LanguageSwitcher(): JSX.Element {
  const { locale, setLocale } = useI18n();
  return (
    <select
      aria-label="Language"
      value={locale}
      onChange={(e) => setLocale(e.target.value as Locale)}
      style={{ padding: '4px 6px', fontSize: 13 }}
    >
      {LOCALES.map((l) => (
        <option key={l} value={l}>
          {LOCALE_LABELS[l]}
        </option>
      ))}
    </select>
  );
}
